/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone'], function(backbone) {
    return backbone.Model.extend({
        defaults: {
            name: '',
            sides: 0,
            selected: false
        },

        initialize: function(options) {
            this.setDefaultName();
        },

        setDefaultName: function() {
            var name = this.get('name');
            var sides = this.get('sides');
            if (!name) {
                if (sides === 1) {
                    name = 'Single-Sided';
                } else if (sides === 2) {
                    name = 'Double-Sided';
                } else if (sides > 2) {
                    name = sides + ' Pages (4 cover + ' + (sides - 4) + ' body)';
                }
            }
            this.set('name', name);
        }
    });
});
